const activitygroup = {
  getlist: 'activitygroup/getlist-by-admin',
  add: 'activitygroup/add',
  update: 'activitygroup/update',
  remove: 'activitygroup/remove',
  get: 'activitygroup/get-by-admin',
  getall: 'activitygroup/getall',
}
export default activitygroup